import { render, staticRenderFns } from "./remove-provider.component.vue?vue&type=template&id=1d307cbb&"
import script from "./remove-provider.component.vue?vue&type=script&lang=ts&"
export * from "./remove-provider.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports